export default {
  ONE: {
    CREATE: {
      REQUEST: 'REQUEST_CREATE_ONE_KIND',
      RECEIVE: 'RECEIVE_CREATE_ONE_KIND',
      FAIL: 'FAIL_CREATE_ONE_KIND',
      NOTIFY: 'NOTIFY_CREATE_ONE_KIND'
    },
    EDIT: {
      REQUEST: 'REQUEST_EDIT_ONE_KIND',
      RECEIVE: 'RECEIVE_EDIT_ONE_KIND',
      FAIL: 'FAIL_EDIT_ONE_KIND',
      NOTIFY: 'NOTIFY_EDIT_ONE_KIND'
    },
    DELETE: {
      REQUEST: 'REQUEST_DELETE_ONE_KIND',
      RECEIVE: 'RECEIVE_DELETE_ONE_KIND',
      FAIL: 'FAIL_DELETE_ONE_KIND',
      NOTIFY: 'NOTIFY_DELETE_ONE_KIND'
    }
  }
}
